import Root from "../views/Root.vue";

import UserDashboard from "../views/patient/Dashboard.vue";
import UserProducts from "../views/patient/Products.vue";
import UserDocuments from "../views/patient/Documents.vue";
import UserDetailOverview from "../views/backoffice/user/details/Overview.vue";
import UserPurchases from "../views/backoffice/user/details/Products.vue";
import DigitalMediaList from "../views/backoffice/products/DigitalMediaList.vue";
import DigitalMediaDetail from "../views/backoffice/products/DigitalMediaDetail.vue";

import { store } from "../store/index.js";
import UserDetailRoot from "../views/backoffice/user/UserDetailRoot.vue";

export const mainRoutes = [
    {
    path: "/main",
    name: "main",
    component: Root,
    beforeEnter(to, from, next) {
      if (store.state.accessToken) {
        window.scrollTo(0, 0);
        next();
      } else {
        window.scrollTo(0, 0);
        next("/?next=" + window.location.pathname);
      }
    },
    props: {
      displayInNavigation: true,
      rerouteToChild: true,
    },
    children: [
      {
        path: "dashboard",
        name: "user_dashboard",
        component: UserDashboard,
        props: {
          displayInNavigation: true,
          icon: "view-dashboard",
          displayName: "dashboard"
        },
      },
      {
        path: "profile",
        name: "user_profile",
        component: UserDetailOverview,
        props: {
          displayInNavigation: true,
          icon: "account",
          displayName: "profile"
        },
      },
      {
        path: "documents",
        name: "user_documents",
        component: UserDocuments,
        props: {
          displayInNavigation: true,
          icon: "file-document-multiple-outline",
          displayName: "documents"
        },
      },
      {
        path: "digitalmedias",
        name: "user_digitalmedias__list",
        component: DigitalMediaList,
        props: {
          displayInNavigation: false,
          icon: "television-classic",
          displayName: "digitalProducts",
        },
      },
      {
        path: "digitalmedias/:digitalMediaID",
        name: "user_digitalmedias__detail",
        component: DigitalMediaDetail,
        props: {
          displayInNavigation: false,
          icon: "television-classic",
          displayName: "digitalProducts",
        },
      },
      {
        path: "products",
        name: "user_products",
        component: UserProducts,
        props: {
          displayInNavigation: false,
          icon: "hand-coin",
          displayName: "landingpageShop",
        },
      },
      {
        path: "purchases",
        name: "user_purchases",
        component: UserDetailRoot,
        props: {
          displayInNavigation: false,
          icon: "play",
          rerouteToChild: true,
          displayName: "purchases"
        },
        children: [
          {
          path: "",
          name: "user_purchases_child",
          component: UserPurchases,
          props: {
            displayInNavigation: true,
            icon: "play",
            displayName: "purchases"
          },
        },
        ]
      },
    ],
  },
]